import Text from "@src/lib/ui/Text";
import { FC } from "react";
import ArrowUpRightIcon from "@src/lib/icons/18px/arrow-up-right";

type Props = {
  url: string;
  text: string;
};

const OpenLinkPill: FC<Props> = (props) => {
  return (
    <a
      href={props.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-9 cursor-pointer items-center justify-center gap-1 rounded-xl bg-gray-6-alpha px-3 backdrop-blur-[18px] hover:bg-gray-7-alpha"
    >
      <Text
        type={"P3"}
        fontWeight={"SemiBold"}
        className="text-white"
        style={{ textTransform: "uppercase" }}
      >
        {props.text}
      </Text>
      <ArrowUpRightIcon className="size-4 text-white" />
    </a>
  );
};

export default OpenLinkPill;
